import { useResponsive } from "@h/useResponsive";
import { Dialog, DialogContent, DialogTitle } from "@ui/dialog";
import ModalCloseButton from "@ui/modal-close-button";
import { Sheet, SheetContent } from "@ui/sheet";
import { useTranslation } from "react-i18next";

// Full-bleed image preview. Mobile = bottom sheet, desktop = dark dialog.
// Extracted from ViewerModal so any surface can preview an asset (media library,
// hotspot viewer). Self-contained: drives its own responsive branch.
export interface ImageLightboxProps {
  open: boolean;
  onClose: () => void;
  src: string;
  alt?: string;
}

export function ImageLightbox({ open, onClose, src, alt }: ImageLightboxProps) {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  return isMobile ? (
    <Sheet open={open} onOpenChange={onClose}>
      <SheetContent
        side="bottom"
        className="p-0 border-none bg-black rounded-t-3xl max-h-[95dvh] flex items-center justify-center"
      >
        <img src={src} className="w-full max-h-[90dvh] object-contain" alt={alt} />
      </SheetContent>
    </Sheet>
  ) : (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        hideClose
        className="p-0 border-none bg-black/90 shadow-none max-w-[95vw] max-h-[95dvh] flex items-center justify-center rounded-2xl overflow-hidden"
      >
        <DialogTitle className="sr-only">{t("expanded_image")}</DialogTitle>
        <div className="absolute top-4 right-4 z-50">
          <ModalCloseButton onClick={onClose} variant="light" />
        </div>
        <img src={src} className="max-w-full max-h-[95dvh] object-contain" alt={alt} />
      </DialogContent>
    </Dialog>
  );
}
